import ProcessTracker from "components/views/modal/ProgressTracker"
import L10n from "lib/carrot-l10n"
import React, { useContext } from "react"
import { Modal } from "components/views/modal/Modal"
import { Container } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export enum EnrollmentType {
  STANDARD,
  QLE_RE_ENROLLMENT,
  INSURANCE_EDIT
}

export type EnrollmentFlowModalContextProps = {
  onExit: () => void
  enrollmentType: EnrollmentType
}

export const EnrollmentFlowModalContext = React.createContext<EnrollmentFlowModalContextProps>(null)

export const useEnrollmentFlowModal = () => useContext(EnrollmentFlowModalContext)

export function EnrollmentModal({ onExit, enrollmentType = EnrollmentType.STANDARD, children }): JSX.Element {
  const context = {
    onExit,
    enrollmentType
  }

  return (
    <Modal titleText={l`Benefit enrollment`} onExit={onExit} underlayClickExits={false}>
      <Container width="100%" paddingLeftRight="huge" stack="huge">
        <EnrollmentFlowModalContext.Provider value={context}>
          <ProcessTracker numSteps="2">{children}</ProcessTracker>
        </EnrollmentFlowModalContext.Provider>
      </Container>
    </Modal>
  )
}
